import React from 'react';
import ReactDOM from 'react-dom';
import keys from 'lodash/keys';
import Page from 'Common/Page/';
import CodeBlock from 'Common/CodeBlock';

import Headshot from './index';

import config from './config.json';

const lgStyle = {
  display: 'block',
  width: '500px',
  height: '550px',
  margin: '2px auto',
};

const smolStyle = {
  display: 'inline-block',
  width: '100px',
  height: '110px',
  margin: '2px',
};

const thinStyle = {
  display: 'inline-block',
  width: '50px',
  height: '55px',
  margin: '2px',
};

class App extends React.Component {
  render() {
    return (
      <Page title='Headshot'>
        <div style={lgStyle}>
          <Headshot
            candidate='kamala-harris'
            blackWhite='false'
            size='lg'
            type='solid'
          />
        </div>
        <div style={smolStyle}>
          <Headshot
            candidate='cycle:2020__office:president__person:kamala-harris'
            blackWhite='false'
            type='solid' />
        </div>
        <div className='test-container' style={smolStyle}>
          <Headshot candidate='cycle:2020__office:president__person:donald-trump' blackWhite='false' type='solid' party='gop' />
        </div>
        <div className='test-container' style={smolStyle}>
          <Headshot candidate='Cory Booker' blackWhite='false' type='solid' />
        </div>
        <div className='test-container' style={smolStyle}>
          <Headshot candidate='P80000722' blackWhite='false' type='solid' />
        </div>
        <div className='test-container' style={smolStyle}>
          <Headshot candidate='cycle:2020__office:president__person:amy-klobuchar' blackWhite='false' type='solid' />
        </div>
        <div className='test-container' style={smolStyle}>
          <Headshot candidate='cycle:2020__office:president__person:robert-o-rourke' blackWhite='false' type='solid' />
        </div>
        <div className='test-container' style={smolStyle}>
          <Headshot
            candidate='cycle:2020__office:president__person:peter-buttigieg'
            blackWhite='false' type='solid'
          />
        </div>
        <div className='test-container' style={smolStyle}>
          <Headshot candidate='cycle:2020__office:president__person:bernard-sanders' blackWhite='false' type='solid' no-cache />
        </div>
        <div className='test-container' style={smolStyle}>
          <Headshot candidate='cycle:2020__office:president__person:john-delaney' blackWhite='false' type='solid' />
        </div>
        <div className='test-container' style={smolStyle}>
          <Headshot candidate='cycle:2020__office:president__person:john-hickenlooper' blackWhite='false' type='outline' />
        </div>
        <div className='test-container' style={thinStyle}>
          <Headshot candidate='cycle:2020__office:president__person:julian-castro' blackWhite='true' type='none' />
        </div>
        <div className='test-container' style={thinStyle}>
          <Headshot size='sm' candidate='cycle:2020__office:president__person:kirsten-gillibrand' blackWhite='false' type='none' />
        </div>
        <div className='test-container' style={thinStyle}>
          <Headshot
            size='sm'
            candidate='cycle:2020__office:president__person:bernard-sanders'
            blackWhite='true'
            type='solid'
            party='ind'
          />
        </div>
        <div className='test-container' style={thinStyle}>
          <Headshot candidate='cycle:2020__office:president__person:kamala-harris'
            size='sm'
            blackWhite='true'
            type='outline'
            party='ind'
          />
        </div>
        <div className='test-container' style={thinStyle}>
          <Headshot size='sm' candidate='cycle:2020__office:president__person:marianne-williamson' blackWhite='false' type='outline' />
        </div>
        <div className='test-container' style={thinStyle}>
          <Headshot size='sm' candidate='cycle:2020__office:president__person:michael-bennet' blackWhite='false' type='none' />
        </div>
        <div className='test-container' style={thinStyle}>
          <Headshot size='sm' candidate='cycle:2020__office:president__person:peter-buttigieg' blackWhite='true' type='solid' />
        </div>
        <div className='test-container' style={thinStyle}>
          <Headshot size='sm' candidate='cycle:2020__office:president__person:joseph-sestak' blackWhite='true' type='outline' />
        </div>
        <div className='test-container' style={thinStyle}>
          <Headshot size='sm' candidate='cycle:2020__office:president__person:tulsi-gabbard' blackWhite='false' type='outline' />
        </div>
        <div className='test-container' style={thinStyle}>
          <Headshot size='sm' candidate='cycle:2020__office:president__person:deval-patrick' blackWhite='false' type='solid' />
        </div>

        <br /><br /><br /><br />
        <p>Click <a target='_blank' href='https://s3.amazonaws.com/interactives.politico.com/interactives/uploads/2020-elections/headshots/archive.zip'>here</a> to download a zip file with all of the images.</p>

        <CodeBlock
          value={`import { Headshot } from '@politico/interactive-style-elections';


// Props
{
  // candidate options: Politico UID, FEC ID, Slug, Name
  "candidate": "cycle:2020__office:president__person:elizabeth-warren",

  // type options: ['solid', 'outline', 'none']
  "type": "solid",

  // blackWhite options: ['true', 'false']
  "blackWhite": "false",

  // size options: ['sm', 'md', 'large']
  "size": "md",

  // amp options: [true, false]
  "amp": false,

  // amp-width: A pixel width value (amp image sizes must be explicit)
  "width": 120,
}


<Headshot candidate='cycle:2020__office:president__person:andrew-yang'
  blackWhite='false'
  type='solid'
  party='dem'
>

/*
 * If you want the headshots to use the direct path to the image instead of the CloudFront cache, use the "no-cache" flag.
 * This should not be the default and uou should only do this if something like the dreaded 503s of late 2019 are back.
 */

 <Headshot candidate='cycle:2020__office:president__person:bernard-sanders'
   blackWhite='false'
   type='solid'
   party='dem'
   no-cache
 >



/* Full list of available candidate slugs:
${config.candidates.map(c => ` * ${(c.slug).toString()}`).join('\n')}
 */
`}
        />
      </Page>
    );
  }
}

export default App;

ReactDOM.render(<App />, document.getElementById('app'));
